// extracted by mini-css-extract-plugin
export default {"mainWrapper":"FeedbackSettings_mainWrapper__y4goJ","mainTitle":"FeedbackSettings_mainTitle__AXaZU"};